import { convertParhato2UserToUser } from "./converters";
import { BaseUsersClient, User, UserWithPassword } from "@core/types";

type RemoveUserResponse = {
  success: boolean;
};

class UsersClient extends BaseUsersClient {
  async getProfile(userId: string): Promise<User> {
    const response = await this.instance.get(`/wp-json/wc/v3/customers/${userId}`);

    return convertParhato2UserToUser(response.data);
  }

  async updateProfile(userId: string, updateData: Partial<UserWithPassword>): Promise<Partial<User>> {
    const userPayload = {
      first_name: updateData.firstName,
      last_name: updateData.lastName,
      email: updateData.email || undefined,
      shipping: {
        first_name: updateData.firstName,
        last_name: updateData.lastName,
      },
      billing: {
        first_name: updateData.firstName,
        last_name: updateData.lastName,
        email: updateData.email || undefined,
        phone: updateData.phone,
      },
      password: updateData.password,
      fcm_token: updateData.fcmToken,
    };

    await this.instance.put<any>(`/wp-json/wc/v3/customers/${userId}`, {
      ...userPayload,
    });
    return updateData;
  }

  async deleteMe(): Promise<{ success: boolean } | null> {
    const { data } = await this.instance.delete<RemoveUserResponse>("/wp-json/wc/v3/customers");

    return data;
  }
}

export default UsersClient;
